<template>

    <data-variable-base :value="value" :variable="variable" @delete="emitDelete(variable)">

        <validation-observer ref="validationObserver" v-slot="{ invalid, errors }">

            <validation-provider
                mode="lazy"
                :name="variable.name"
                rules="required"
                v-slot="{ errors }">

                <v-combobox
                    v-show="!isMasked"
                    v-model="answer"
                    :items="variable.options"
                    chips
                    :label="variable.name.replace('_',' ')"
                    item-text="name"
                    item-value="unique_id"
                    :persistent-hint="!!hint"
                    :hint="hint"
                    :hide-details="!hint && errors.length === 0 && !errorMessages[variable.name]"
                    :error-messages="errors.length > 0 ? errors : errorMessages[variable.name]"
                    :disabled="isDisabled"
                    placeholder="NO RECORDED VALUE"
                    class="align-self-center flex-grow-1"
                    @change="optionChanged">

                    <template v-slot:selection="data">
                        <v-chip color="grey darken-1">
                            {{ data.item.name }}
                        </v-chip>
                    </template>

                </v-combobox>

            </validation-provider>

        </validation-observer>

    </data-variable-base>

</template>

<script>

import Json from 'vue-json-pretty';
import MaskedField from './MaskedField';
import {dataVariableInputMixin} from './dataVariableInputMixin';
import DataVariableBase from "./DataVariableBase";

export default {

    mixins: [dataVariableInputMixin],

    components: {
        DataVariableBase,
        MaskedField,
        Json
    },

    props: {
        value: {
            type: Number | null,
            required: true
        },
    },

    watch: {
        value(value) {
            this.model = value;
        },
    },

    data() {
        return {
            model: null,
        }
    },

    methods: {
        optionChanged(option) {
            this.model = option.unique_id;
            this.emit(option.unique_id);
        }
    },

    computed: {

        answer: {
            get() {
                if (this.model) {
                    return this.variable.options.find(option => option.unique_id === this.model);
                } else {
                    return this.variable.options.find(option => option.unique_id === this.value);
                }
            },
            set(value) {
                this.model = value;
            }
        }
    },

    mounted() {
        if (this.value) {
            this.model = this.variable.options.find(option => option.unique_id === this.value).value;
        }
    }
}
</script>
